import React from "react";
import ReactDOM from "react-dom/client";
import { applyTheme } from "./design/tokens";   // [D8 2026-06-10] apply the LIGHT theme Blake landed on
import ROClassifier from "./classifier";
import AdminApp from "./admin";

applyTheme("light");  // sets T (kit tokens) + body backdrop to light before render

const isAdmin = window.location.pathname.startsWith("/admin");
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isAdmin ? <AdminApp /> : <ROClassifier />}
  </React.StrictMode>
);
